(function(window, document, $, undefined){
  

  
    // -----------------------------------------------------------------------------------------------------
    // Tooltips - https://kazzkiq.github.io/balloon.css/
    // -----------------------------------------------------------------------------------------------------

    // whatever has a tooltip class added, e.g. simptip-fade it will put the title arrtibute in the data-tooltip attribute.

    // balloon tooltips
      // $('.tooltip a, .tooltip-down a').attr('data-balloon',$(this).attr('title'));
      // $('.tooltip a').attr('data-balloon-pos','up');
      // $('.tooltip-down a').attr('data-balloon-pos','down');

      // $('.tooltip, .tooltip-down').attr('data-balloon',$(this).attr('title'));

      //add the tooltip text from the title attr
      $('.tooltip, .tooltip-left, .tooltip-right, .tooltip-down').each(function(index, el) {
        var title = $(this).attr('title');
        $(this).attr('data-balloon',title);
      });
      $('.tooltip').attr('data-balloon-pos','up');
      $('.tooltip-left').attr('data-balloon-pos','left');
      $('.tooltip-right').attr('data-balloon-pos','right');
      $('.tooltip-down').attr('data-balloon-pos','down');
      
      //fix for menu items
      $('.menu .tooltip, .menu .tooltip-down').each(function(index, el) {
        var a = $(this).find('a');
        a.attr('data-balloon',a.attr('title'));
        a.attr('data-balloon-pos',$(this).attr('data-balloon-pos'));
        $(this).removeAttr('data-balloon');
        $(this).removeAttr('data-balloon-pos');
      });

  // simptip
    // // $('[class^="simptip-"]').attr('data-tooltip',$(this).attr('title'));

    // // fix menus caus the attr and titles appear on the li and mess it up.
    // var simptips = [
    //   'half-arrow',
    //   'simptip-smooth',
    //   'simptip-fade',
    //   'simptip-movable',
    //   'simptip-multiline',
    //   'simptip-success',
    //   'simptip-info',
    //   'simptip-warning',
    //   'simptip-danger',
    //   'simptip-position-right',
    //   'simptip-position-bottom',
    //   'simptip-position-left',
    // ];
    // for (var i = simptips.length - 1; i >= 0; i--) {
    //   $('.menu li.'+simptips[i]).each(function(index, el) {
    //     $(this).removeClass(simptips[i]);
    //     var a = $(this).find('a');
    //     a.addClass(simptips[i]).attr('data-tooltip',a.attr('title'));
    //   });
    // }


})(window, document, jQuery);
